import { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';

import Main from '../../../layouts/Main';
import Container from '../../../components/Container';
import { Divider } from '@mui/material';

import PressRelease from '../../../types/communication/pressRelease';
import ChronologicalButtonList from '../../Legal/components/ChronologicalButtonList';
import PageBreadCrumbs from '../../../components/PageBreadcrumbs';


const PressReleases = (): JSX.Element => {
  const theme = useTheme();

  const [PressReleases, setPressReleases] = useState<PressRelease[]>([]);

  const years = Array.from({ length: new Date().getFullYear() - 1997 + 1 }, (_, i) => new Date().getFullYear() - i);
  
  useEffect(() => {
    getPressReleases();
  }, [])


  const getPressReleases = async () => {
    try{
      await fetch(`${process.env.REACT_APP_API_BASE_URL}/releases`)
      .then(result => result.json())
      .then(result => {
        setPressReleases(result)
      });
    }catch(error){
      console.error('Uncaught Error:', error);
    }
    
  }
  

  return (
    <Main>
      <Container>
      <PageBreadCrumbs></PageBreadCrumbs>
        <Typography
            variant="h4"
            align={'left'}
            data-aos={'fade-up'}
            sx={{
                fontWeight: 700,
            }}
            paddingTop={3}
            gutterBottom
            marginBottom={2}
            >
            Press Releases
        </Typography>
        <Divider/>
        <ChronologicalButtonList years={years} PressReleases={PressReleases} eLibraryDocumentType={'Press Releases'}/>
      </Container>
    </Main>
  );
};

export default PressReleases;